import { 
  OPEN_MODAL_LOGIN,
  CLOSE_MODAL_LOGIN 
} from '../actions/ModalLoginActions';

const initialState = {
  isOpen: false
};

export function ModalLoginReducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_MODAL_LOGIN: {
      return {
        isOpen: true
      }
    }
    case CLOSE_MODAL_LOGIN: {
      return {
        isOpen: false
      }
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/ModalLoginReducer.js